const styles = theme => ({
    paper:{
        position:'absolute',
        borderLeft:`1px solid ${theme.AppBGColor}`,
        boxShadow:"none",
        width:350,
        boxSizing:"border-box",
        backgroundColor: theme.gridBGColor,
        transform:'translate(0px, 0px)',
        userSelect:'none',
        color:theme.TextColor,
        overflow:"hidden",
        zIndex:0
    },
    backdrop:{
        position:'absolute',
        backgroundColor:"transparent"
   },
   modal:{
        position:'absolute',
        height:"inherit"
   },
   head:{
       fontSize: 14,
       color: theme.HeaderSelectedText,
       padding: "8px 24px",
       fontWeight: 600,
       flexBasis:"auto"
   },
   data:{
       fontSize: theme.textFontSize,
       color: theme.gridTextColor,
       overflowY:"auto",
       margin:0,
       padding:"0 24px",
       height:"100%",
       maxHeight:"calc(100% - 100px)"
   },
   group:{
       padding:"12px 0"
   },
   paddingTop:{
    paddingTop: 16
   },
   actionContainer:{
       display:'flex',
       justifyContent:'space-between'
   },
   editorContainerLabel:{
        lineHeight: "30px"
   },
   editorContainer:{
    '& > *':{
        marginTop:0
    },
    '& .select__control':{
        marginTop:0,
        minHeight:30,
        borderRadius:4,
        '& .select__indicators':{
            height: 28
        },
        '&:hover,&.select__control--is-focused':{
            borderRadius: 4
        }
    },
   },
   editorContainerTime:{
        '&>div':{
            maxWidth:"100%",
            marginTop:0,
            '&>div':{
                width:"100%",
                '&>div':{
                    maxWidth:"100%",
                    height:30,
                    borderRadius:4
                }
            }
        }
   },
   item:{
       lineHeight:"24px"
   },
   statusIcon:{
       fontSize:12,
       color: theme.palette.primary.main,
   },
   lockStateText:{
       fontSize:8,
       color: theme.TextColor,
       padding: "4px 0"
   },
   toggleGroup:{
       display:'flex',
       borderRadius:4,
       backgroundColor: theme.gridBGColor,
       boxShadow:'none'
   },
   toggleButtonSelected:{
        backgroundColor: theme.routeLockBGColor,
   },
   toggleButton:{
       padding:6,
       flexGrow:1,
       border:`1px solid ${theme.iconColor}`,
       height:40,
       // below styles are taken from materialUI v4 where toggle button has borders
       '&:first-child':{
           marginLeft:1,
           borderTopLeftRadius:4,
           borderBottomLeftRadius:4,
       },
       '&:last-child':{
            borderTopRightRadius:4,
            borderBottomRightRadius:4,
       },
       '&:not(:first-child)':{
           marginLeft:-1,
           borderLeftColor:"transparent"
       },
       '&:hover':{
            backgroundColor: theme.routeLockBGColor,
        },
       '&$toggleButtonSelected':{
            backgroundColor: theme.routeLockBGColor,
            borderColor:theme.palette.primary.main,
            '&:hover':{
                backgroundColor: theme.routeLockBGColor,
            }
       }
   },
   comments:{
    color: theme.TextColor,
    lineHeight: "20px",
    fontSize: theme.textFontSize,
    '& $commentsBorder':{
        borderColor:theme.iconColor
    }
   },
   commentsBorder:{},
   formControl:{
       width:"100%",
       '& $comments $commentsBorder':{
            borderColor:`${theme.iconColor} !important`,
            borderWidth:1
       }
   },
   errorColor:{
       paddingTop:4,
       fontSize:11,
       color: theme.ErrorMessageColor
   },
   statusLabel:{
       lineHeight:"40px"
   },
   formAction:{
       position:'absolute',
       width:"100%",
       margin: 0,
       bottom:0,
       right:0,
       padding:"8px 16px"
   },
   actionButton:{
       width:"45%",
       minWidth:"45%",
       textTransform: 'none',
       '&$actionDisabled, &$actionDisabled:hover':{
           cursor:"not-allowed",
           pointerEvents:"all",
           backgroundColor:"transparent",
           opacity:0.7,
           color: theme.TextColor,
           border:`1px solid ${theme.iconColor}`,
           '&$activeButton':{
                borderColor:theme.HeaderSelectedText
            },
            '&$activePrimaryButton':{
                backgroundColor:theme.HeaderSelectedText,
                border:theme.HeaderSelectedText,
                color:"white"
            }
       },
   },
   activeButton:{},
   activePrimaryButton:{},
   actionDisabled:{
   },
   actionContained:{

   },
   divider:{
       backgroundColor: theme.AppBGColor
   },
   hideContent:{
    display: 'none'
   },
   showContent:{
    display: 'block',
    height: '100%'
   },
   checkbox:{
       padding:0,
       color: theme.iconColor
   },
   trapRouteWarning:{
       color: theme.ErrorMessageColor,
   },
   radio:{
        padding:"0 12px",
        color: theme.iconColor,
        '&$radioDisabled':{
            color: theme.iconColor
        }
   },
   radioLabel:{
       fontSize:theme.textFontSize,
       color: theme.TextColor,
       '&$radioDisabled':{
        color: theme.iconColor
    }
   },
   radioDisabled:{
    color: theme.iconColor
   },
   holdProWarning:{
    color: theme.ErrorMessageColor,
    paddingBottom: 6
   }
});

export default styles;
